import React from 'react';

import { Stack } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid';

import { Order } from '@luxuryescapes/contract-svc-order';

import orderCurrencyFormatter from './orderCurrencyFormatter';
import orderTotalFormatter from './orderTotalFormatter';

const orderTotalCurrencyFormatter = (params: GridRenderCellParams<Order.Order>) => {
  return (
    <Stack direction="column">
      {orderTotalFormatter(params)}
      {orderCurrencyFormatter(params)}
    </Stack>
  );
};

export default orderTotalCurrencyFormatter;
